<script lang="ts" setup>
import { useRouter } from 'vue-router'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n';

const router = useRouter()
const { t, locale } = useI18n()

const searchValue = ref('')

function search(){
    if(searchValue.value.length>0){
        router.push({name: locale.value+'.search', query: {s: searchValue.value}})
    }
}
</script>
<template>
    <form @submit.prevent="search">
        <input type="text" name="s" v-model="searchValue" :placeholder="$t('search_input')" />
    </form>
</template>

<style lang="scss" scoped>
input {
    max-width: 100%;
    width: 426px;
    height: 45px;
    background-color: #FFF;
    border: 2px solid #DC0303;
    border-radius: 30px;
    padding: 8px 15px;
    font-size: 14px;
    line-height: 17px;
    &::placeholder{
        color: #C6C6C6;
    }
}
</style>